import Vue from 'vue'
import { AlertPlugin, ConfirmPlugin } from "vux"

Vue.use(AlertPlugin);
Vue.use(ConfirmPlugin);

/*
alert 관련 메시지 이벤트 저장 후 사용
 */

export default {
  methods: {
     createAlert(params){
       this.$vux.alert.show({
         title: params.title,
         content: params.content,
         buttonText: params.btnText,
         onHide () {
           if(params.func){
             params.func();
           }
           if(params.back){
             window.history.back();
           }
         }
       })
     },
    listDeleteAlert(params){
      this.$vux.confirm.show({
        title: '알림',
        content: '삭제하시겠습니까?',
        confirmText: "확인",
        cancelText: "취소",
        onCancel () {

        },
        onConfirm () {
          params.element.dataDelete(params.key);
        }
      });
    },

    fileDeleteAlert(params){
      this.$vux.confirm.show({
        title: '알림',
        content: '삭제하시겠습니까?',
        confirmText: "확인",
        cancelText: "취소",
        onCancel () {

        },
        onConfirm () {
          params.element.apiFileDelete(params.index , params.key );
        }
      });
    },

    saveAlert(params){
      this.$vux.confirm.show({
        title: '확인',
        content: '등록완료',
        confirmText: "리스트가기",
        cancelText: "새로등록",
        onCancel () {
          if(params.editor){
            $('#'+params.id).summernote('code', '');
          }
          params.element.initData();
        },
        onConfirm () {
          window.history.back();
        }
      });
    },

    updateAlert(params=null){
      this.$vux.confirm.show({
        title: '확인',
        content: '수정완료',
        confirmText: "리스트가기",
        cancelText: "재수정하기",
        onCancel () {
          if(params != null && params.getDetail) {
            params.getDetail();
          }
        },
        onConfirm () {
          window.history.back();
        }
      });
    },

    deleteAlert(params){
      this.$vux.alert.show({
        title: '확인',
        content: '삭제완료',
        buttonText: '확인',
        onHide () {
          params.element.getList();
        }
      })
    },

    validateAlert(params){
      this.$vux.alert.show({
        title: '알림',
        content: '필수 데이터를 확인해주세요',
        buttonText: '확인',
        onHide () {
        }
      })
    },

    errorAlert(params){
      this.$vux.alert.show({
        title: '알림',
        content: params,
        buttonText: '확인',
        onHide () {
        }
      })
    },

  }
}
